import React, { useContext, useEffect, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { getLocal, setLocal } from '../../helper/storage'
import CustomModal from '../../component/customModal'
import TermsAndCondition from '../../component/termsAndCondition'
import { useDispatch, useSelector } from 'react-redux'
import cleaning_tool from '../../assets/img/svg/cleaning_tool.svg'
import peoole from '../../assets/img/svg/people.svg'
import homes from '../../assets/img/svg/homes_icon.svg'
// import pipline from '../../assets/img/svg/pipline_icon.svg'
import Complate_img from '../../assets/img/completed-image.png'
import Progress_img from '../../assets/img/in-progress-image.png'
import CalImg from '../../assets/img/calendar-image.png'

import calender from '../../assets/img/calendar.svg'
import { SpinnerContext } from '../../context/spinnerContext'
import { getAllRegions } from '../../redux/slices/scheduleSlice'
import { getAllPropertiesName } from '../../redux/slices/propertySlice'
import { getCleaningStatInfo, getCleanningStatus, getRecentCleanning, getUpcomingCleanning } from '../../redux/slices/dashboardSlice'
import CustomSlider from '../../component/customSlider'
import CustomImageCarousel from '../../component/customImageCarousel'
import { convertTimestampToDate, convertTimestampToTime, generateNumberPattern, getTimeStamp, getWindowDivSize, OVERDUE } from '../../helper/function'
import NoDataFound from '../../component/noDataFound'

const Dashboard = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => auth)
  const { allRegions } = useSelector(({ schedule }) => schedule)
  const { allPropertiesName } = useSelector(({ property }) => property)
  const { dashboardCounts, recentCleanningData, cleanningStatusData, upcomingCleanningData } = useSelector(({ dashboard }) => dashboard)
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [selectedProperty, setSelectedProperty] = useState(null)
  const { loader, changeLoader } = useContext(SpinnerContext)
  // eslint-disable-next-line no-unused-vars
  const [isRefresh, setIsRefresh] = useState(false)
  const isTermAccepted = getLocal('isTermAccepted')
  const [showTermsandConditionModal, setShowTermsandConditionModal] = useState(false)
  const [pageSize, setPageSize] = useState(getWindowDivSize())

  const [recentCleanningPage, setRecentCleanningPage] = useState(1)
  const [recentCleanningSlides, setRecentCleanningSlides] = useState([0])
  const [recentCleanningState, setRecentCleanningState] = useState([])
  const [recentCleanningHashMore, setRecentCleanningHashMore] = useState(true)
  const [recentVisitSlide, setRecentVisitSlide] = useState(0)

  const [statusPage, setStatusPage] = useState(1)
  const [cleanningStatusSlides, setCleanningStatusSlides] = useState([0])
  const [statusState, setStatusState] = useState([])
  const [statusHashMore, setStatusHashMore] = useState(true)
  const [statusVisitSlide, setStatusVisitSlide] = useState(0)

  const [upcomingCleanningPage, setUpcomingCleanningPage] = useState(1)
  const [upcomingCleanningSlides, setUpcomingCleanningSlides] = useState([0])
  const [upcomingCleanningState, setUpcomingCleanningState] = useState([])
  const [upcomingCleanningHashMore, setupcomingCleanningHashMore] = useState(true)
  const [upcomingCleanningVisitSlide, setUpcomingCleanningVisitSlide] = useState(0)

  const REC1ID = 'recentCleanning'
  const REC2ID = 'statusCleanning'
  const REC3ID = 'upcomingCleanning'

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (statusState?.length === cleanningStatusData?.totalRecords) {
      setStatusHashMore(false)
    }
  }, [statusState, cleanningStatusData])

  useEffect(() => {
    if (recentCleanningState?.length === recentCleanningData?.totalRecords) {
      setRecentCleanningHashMore(false)
    }
  }, [recentCleanningState, recentCleanningData])

  useEffect(() => {
    if (upcomingCleanningState?.length === upcomingCleanningData?.totalRecords) {
      setupcomingCleanningHashMore(false)
    }
  }, [upcomingCleanningState, upcomingCleanningData])

  useEffect(() => {
    if (cleanningStatusData.propertySchedules) {
      setStatusState((prev) => [...prev, ...cleanningStatusData.propertySchedules])
    }
  }, [cleanningStatusData.propertySchedules])

  useEffect(() => {
    if (recentCleanningData.propertySchedules) {
      setRecentCleanningState((prev) => [...prev, ...recentCleanningData.propertySchedules])
    }
  }, [recentCleanningData.propertySchedules])

  useEffect(() => {
    if (upcomingCleanningData.propertySchedules) {
      setUpcomingCleanningState((prev) => [...prev, ...upcomingCleanningData.propertySchedules])
    }
  }, [upcomingCleanningData.propertySchedules])

  useEffect(() => {
    if (cleanningStatusData?.totalRecords) {
      setCleanningStatusSlides(generateNumberPattern(cleanningStatusData?.totalRecords, pageSize))
    }
  }, [cleanningStatusData?.totalRecords])

  useEffect(() => {
    if (recentCleanningData?.totalRecords) {
      setRecentCleanningSlides(generateNumberPattern(recentCleanningData?.totalRecords, pageSize))
    }
  }, [recentCleanningData?.totalRecords])

  useEffect(() => {
    if (upcomingCleanningData?.totalRecords) {
      setUpcomingCleanningSlides(generateNumberPattern(upcomingCleanningData?.totalRecords, pageSize))
    }
  }, [upcomingCleanningData?.totalRecords])

  useEffect(() => {
    // Show the modal if terms are not accepted
    if (user?.is_term_accepted === false && isTermAccepted === 'false') {
      setShowTermsandConditionModal(true)
    }
  }, [user])

  useEffect(() => {
    const fetchData = async () => {
      changeLoader(true)
      try {
        dispatch(getAllRegions())
        dispatch(getAllPropertiesName())
      } catch (err) {
        console.error('>>Err:', err)
      } finally {
        changeLoader(false)
      }
    }
    user && fetchData()
    handleResize()
  }, [])

  useEffect(() => {
    dashboardCountDetails()
  }, [selectedRegion, selectedProperty])

  useEffect(() => {
    getRecentCleanningDetails()
  }, [selectedRegion, selectedProperty, recentCleanningPage])

  useEffect(() => {
    getStatusPropertySchedule()
  }, [selectedRegion, selectedProperty, statusPage])

  useEffect(() => {
    getUpcomingDetails()
  }, [selectedRegion, selectedProperty, upcomingCleanningPage])

  const dashboardCountDetails = () => {
    const params = {
      region_id: selectedRegion,
      properties_id: selectedProperty
    }
    changeLoader(true)
    dispatch(getCleaningStatInfo(params))
      .then(() => {
        changeLoader(false)
      })
      .catch((err) => {
        console.error('>>Err:', err)
        changeLoader(false)
      })
  }

  const getRecentCleanningDetails = () => {
    if (!recentCleanningHashMore) {
      return
    }
    const params = {
      region_id: selectedRegion,
      properties_id: selectedProperty,
      page: recentCleanningPage,
      limit: pageSize
    }
    changeLoader(true)
    dispatch(getRecentCleanning(params))
      .then(() => {
        changeLoader(false)
      })
      .catch((err) => {
        console.error('>>Err:', err)
        changeLoader(false)
      })
  }

  const getStatusPropertySchedule = () => {
    if (!statusHashMore) {
      return
    }
    const params = {
      region_id: selectedRegion,
      properties_id: selectedProperty,
      page: statusPage,
      limit: pageSize
    }
    changeLoader(true)
    dispatch(getCleanningStatus(params))
      .then(() => {
        changeLoader(false)
      })
      .catch((err) => {
        console.error('>>Err:', err)
        changeLoader(false)
      })
  }

  const getUpcomingDetails = () => {
    if (!upcomingCleanningHashMore) {
      return
    }
    const params = {
      region_id: selectedRegion,
      properties_id: selectedProperty,
      page: upcomingCleanningPage,
      limit: pageSize
    }
    changeLoader(true)
    dispatch(getUpcomingCleanning(params))
      .then(() => {
        changeLoader(false)
      })
      .catch((err) => {
        console.error('>>Err:', err)
        changeLoader(false)
      })
  }

  const toggleTermsandConditionModal = () => {
    setShowTermsandConditionModal(!showTermsandConditionModal)
    setLocal('isTermAccepted', 'true')
  }

  const clearAllState = (clearAll) => {
    if (!clearAll) {
      setStatusState([])
      setRecentCleanningState([])
      setUpcomingCleanningState([])
    }
    setStatusPage(1)
    setRecentCleanningPage(1)
    setUpcomingCleanningPage(1)
    setStatusHashMore(true)
    setupcomingCleanningHashMore(true)
    setRecentCleanningHashMore(true)
  }

  const handleSelectRegion = (region_id) => {
    if (selectedRegion === region_id) {
      clearAllState(true)
    } else {
      clearAllState(false)
    }
    setSelectedRegion(region_id)
  }

  const handleSelectProperty = (propertyId) => {
    if (selectedProperty === propertyId) {
      clearAllState(true)
    } else {
      clearAllState(false)
    }
    setSelectedProperty(propertyId)
  }

  const handleNextClick = (id, curr) => {
    if (id === REC1ID) {
      setRecentCleanningPage(curr)
    } else if (id === REC2ID) {
      setStatusPage(curr)
    } else if (id === REC3ID) {
      setUpcomingCleanningPage(curr)
    }
  }

  const showStatusImg = (status) => {
    return status === 'scheduled'
      ? CalImg
      : ['completed', 'canceled cleaner']?.includes(status)
        ? Complate_img
        : status === 'in progress'
          ? Progress_img
          : ''
  }

  const handleResize = () => {
    setPageSize(getWindowDivSize())
  }

  return (
    <>
      <div className="page-wrapper">
        {/* Filter section */}
        <div className="deshboard_topbar">
          <div className="schedule_sec">
            <div className="regions_sec">
              <Dropdown>
                <Dropdown.Toggle className="dropdown_opction_one" variant="success" id="dropdown-basic">
                  {selectedRegion ? allRegions?.find((region) => region.region_id === selectedRegion)?.region : 'Regions'}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSelectRegion(null)}>All Regions</Dropdown.Item>
                  {allRegions?.map((region) => (
                    <Dropdown.Item key={region.region_id} onClick={() => handleSelectRegion(region.region_id)}>
                      {region.region}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="regions_sec">
              <Dropdown>
                <Dropdown.Toggle className="dropdown_opction_one" variant="success" id="dropdown-basic">
                  {selectedProperty ? allPropertiesName?.find((prop) => prop.properties_id === selectedProperty).property_name : 'Properties'}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSelectProperty(null)}>All Properties</Dropdown.Item>
                  {allPropertiesName?.map((property) => (
                    <Dropdown.Item
                      key={property.properties_id}
                      className="dropdown_opction"
                      onClick={() => handleSelectProperty(property.properties_id)}
                    >
                      <div className="dropdown_btn_menu_item_div">{property.property_name}</div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        {/* Dashboard count start */}
        <div className="row deshboard_subdatasec_topbar mb-3">
          <div className="col-md-6 col-lg-4 col-xl-4 subdatasec_topbar_box">
            <div className="subdatasec_topbar">
              <div>
                <h4 className="cleanings_month_text"> {dashboardCounts?.currentMonthCleaning || 0} </h4>
                <h4 className="cleanings_month_subtext"> Cleanings Month </h4>
              </div>
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={cleaning_tool} alt="cleaning_tool" />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-xl-4 subdatasec_topbar_box">
            <div className="subdatasec_topbar">
              <div>
                <h4 className="cleanings_month_text"> {dashboardCounts?.totalCleaning || 0} </h4>
                <h4 className="cleanings_month_subtext"> Total Cleanings </h4>
              </div>
              <div className="deshboard_topbar_imgsec">
                <img className="peoole_img" src={peoole} alt="peoole" />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-xl-4 subdatasec_topbar_box">
            <div className="subdatasec_topbar">
              <div>
                <h4 className="cleanings_month_text"> {dashboardCounts?.propertiesCount || 0} </h4>
                <h4 className="cleanings_month_subtext"> Properties </h4>
              </div>
              <div className="deshboard_topbar_imgsec">
                <img className="homes_img" src={homes} alt="homes" />
              </div>
            </div>
          </div>
          {/* <div className="col-md-6 col-lg-3 col-xl-3 subdatasec_topbar_box">
            <div className="subdatasec_topbar">
              <div>
                <h4 className="cleanings_month_text"> 0 </h4>
                <h4 className="cleanings_month_subtext"> Total Damaged Objects </h4>
              </div>
              <div className="deshboard_topbar_imgsec">
                <img className="pipline_img" src={pipline} alt="pipline" />
              </div>
            </div>
          </div> */}
        </div>
        {/* recent cleaning Start */}
        {recentCleanningState?.length > 0 && (
          <div className="recent_cleaning_sec mt-4">
            <h5 className="recent_cleaning_text">Recent Cleaning</h5>
            {recentCleanningData?.totalRecords ? (
              <CustomSlider
                onNextClick={handleNextClick}
                page={recentCleanningPage}
                id={REC1ID}
                visitSlide={recentVisitSlide}
                setVisitSlide={setRecentVisitSlide}
              >
                {recentCleanningSlides?.map((_, index) => {
                  let CheckTimeOver =
                    recentCleanningState?.[index]?.booking_status !== 'completed'
                      ? getTimeStamp(new Date()) >= recentCleanningState?.[index]?.booking_date_time
                      : false
                  return (
                    <div className="recent_cleaning_slider_box1" key={`slider-key-${index}`}>
                      <div className="recent_cleaning_main_div">
                        <CustomImageCarousel imageList={recentCleanningState?.[index]?.properties?.property_image || []} />
                        <img className="action_img" src={showStatusImg(recentCleanningState?.[index]?.booking_status)} alt="Action Image" />
                      </div>
                      <div className="mt-3">
                        <div className="d-flex align-content-center gap-2 justify-content-between">
                          <h4 className="recent_cleaning_slider_text">{recentCleanningState?.[index]?.properties?.property_name}</h4>
                          <div className="d-flex align-items-center gap-2 data_width">
                            <img className="calender" src={calender} alt="Icon" />
                            <span className="property_slider_sec_schedule">{recentCleanningState?.[index]?.booking_status} </span>
                          </div>
                        </div>
                        <div className="d-flex align-content-left mb-2" style={{ justifyContent: 'flex-end' }}>
                          {!['completed', 'canceled', 'canceled cleaner']?.includes(recentCleanningState?.[index]?.booking_status) && (
                            <span className="red_color"> {CheckTimeOver ? OVERDUE : ''}</span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <h3 className="date_text">{convertTimestampToDate(recentCleanningState?.[index]?.booking_date_time)}</h3>
                          <h3 className="date_text">{convertTimestampToTime(recentCleanningState?.[index]?.booking_date_time)}</h3>
                        </div>
                        <h4 className="recent_cleaning_slider_subtext">{recentCleanningState?.[index]?.properties?.address} </h4>
                      </div>
                    </div>
                  )
                })}
              </CustomSlider>
            ) : (
              <></>
            )}
          </div>
        )}

        {/* cleaning status Start */}
        {statusState?.length > 0 && (
          <div className="recent_cleaning_sec mt-4">
            <h5 className="recent_cleaning_text">Cleaning Status</h5>
            {cleanningStatusData?.totalRecords ? (
              <CustomSlider
                onNextClick={handleNextClick}
                page={statusPage}
                id={REC2ID}
                visitSlide={statusVisitSlide}
                setVisitSlide={setStatusVisitSlide}
              >
                {cleanningStatusSlides?.map((_, index) => {
                  let CheckTimeOver =
                    statusState?.[index]?.booking_status !== 'completed' ? getTimeStamp(new Date()) >= statusState?.[index]?.booking_date_time : false
                  return statusState?.[index]?.booking_status ? (
                    <div className="recent_cleaning_slider_box1" key={`slider-key-${index}`}>
                      <div className="recent_cleaning_main_div">
                        {statusState?.[index]?.booking_status ? (
                          <CustomImageCarousel imageList={statusState?.[index]?.properties?.property_image || []} />
                        ) : (
                          <div className="property_slider_img"></div>
                        )}
                        {statusState?.[index]?.booking_status && (
                          <img className="action_img" src={showStatusImg(statusState?.[index]?.booking_status)} alt="Action Image" />
                        )}
                      </div>
                      <div className="mt-3">
                        <div className="d-flex align-content-center gap-2 justify-content-between">
                          <h4 className="recent_cleaning_slider_text">{statusState?.[index]?.properties?.property_name}</h4>
                          {statusState?.[index]?.booking_status && (
                            <div className="d-flex align-items-center gap-2 data_width">
                              <img className="calender" src={calender} alt="Icon" />
                              <span className="property_slider_sec_schedule">{statusState?.[index]?.booking_status} </span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex align-content-left mb-2" style={{ justifyContent: 'flex-end' }}>
                          {!['completed', 'canceled', 'canceled cleaner']?.includes(statusState?.[index]?.booking_status) && (
                            <span className="red_color"> {CheckTimeOver ? OVERDUE : ''}</span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          {statusState?.[index]?.booking_date_time && (
                            <h3 className="date_text">{convertTimestampToDate(statusState?.[index]?.booking_date_time)}</h3>
                          )}
                          {statusState?.[index]?.booking_date_time && (
                            <h3 className="date_text">{convertTimestampToTime(statusState?.[index]?.booking_date_time)}</h3>
                          )}
                        </div>
                        <h4 className="recent_cleaning_slider_subtext">{statusState?.[index]?.properties?.address} </h4>
                      </div>
                    </div>
                  ) : (
                    <div className="recent_cleaning_slider_box1">
                      <div className="property_slider_img" style={{ backgroundColor: '#ECFBFF', minHeight: '380px' }}></div>
                    </div>
                  )
                })}
              </CustomSlider>
            ) : (
              <></>
            )}
          </div>
        )}

        {/* upcoming check-ins Start */}
        {upcomingCleanningState?.length > 0 && (
          <div className="recent_cleaning_sec mt-4">
            <h5 className="recent_cleaning_text">Upcoming Check-Ins</h5>
            {upcomingCleanningData?.totalRecords ? (
              <CustomSlider
                onNextClick={handleNextClick}
                page={upcomingCleanningPage}
                id={REC3ID}
                visitSlide={upcomingCleanningVisitSlide}
                setVisitSlide={setUpcomingCleanningVisitSlide}
              >
                {upcomingCleanningSlides?.map((_, index) => {
                  let CheckTimeOver =
                    upcomingCleanningState?.[index]?.booking_status !== 'completed'
                      ? getTimeStamp(new Date()) >= upcomingCleanningState?.[index]?.booking_date_time
                      : false
                  return (
                    <div className="recent_cleaning_slider_box1" key={`slider-key-${index}`}>
                      <div className="recent_cleaning_main_div">
                        <CustomImageCarousel imageList={upcomingCleanningState?.[index]?.properties?.property_imag || []} />
                        <img className="action_img" src={showStatusImg(upcomingCleanningState?.[index]?.booking_status)} alt="Action Image" />
                      </div>
                      <div className="mt-3">
                        <div className="d-flex align-content-center gap-2 justify-content-between">
                          <h4 className="recent_cleaning_slider_text">{upcomingCleanningState?.[index]?.properties?.property_name}</h4>
                          <div className="d-flex align-items-center gap-2 data_width">
                            <img className="calender" src={calender} alt="Icon" />
                            <span className="property_slider_sec_schedule">{upcomingCleanningState?.[index]?.booking_status} </span>
                          </div>
                        </div>
                        <div className="d-flex align-content-left mb-2" style={{ justifyContent: 'flex-end' }}>
                          {!['completed', 'canceled', 'canceled cleaner']?.includes(upcomingCleanningState?.[index]?.booking_status) && (
                            <span className="red_color"> {CheckTimeOver ? OVERDUE : ''}</span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <h3 className="date_text">{convertTimestampToDate(upcomingCleanningState?.[index]?.booking_date_time)}</h3>
                          <h3 className="date_text">{convertTimestampToTime(upcomingCleanningState?.[index]?.booking_date_time)}</h3>
                        </div>
                        <h4 className="recent_cleaning_slider_subtext">{upcomingCleanningState?.[index]?.properties?.address} </h4>
                      </div>
                    </div>
                  )
                })}
              </CustomSlider>
            ) : (
              <></>
            )}
          </div>
        )}
        {loader ? (
          <></>
        ) : (
          recentCleanningState?.length === 0 &&
          statusState?.length == 0 &&
          upcomingCleanningState?.length == 0 && <NoDataFound title="No Data Found" />
        )}
      </div>

      {showTermsandConditionModal && (
        <CustomModal isOpen={showTermsandConditionModal} toggle={toggleTermsandConditionModal} isTitle={false} size="lg">
          <TermsAndCondition setShowTermsandConditionModal={setShowTermsandConditionModal} setIsRefresh={setIsRefresh} />
        </CustomModal>
      )}
    </>
  )
}

export default Dashboard
